import React from 'react';
import styles from './toolbar-button.less.js';
import { hexToRgb, parseRgb, isLightColor } from '../../../utils/color-utils.js';

function ColorIndicator({ color, className }) {
    var _a;
    if (!color) {
        return null;
    }
    const rgbColor = (_a = hexToRgb(color)) !== null && _a !== void 0 ? _a : parseRgb(color);
    const isLight = isLightColor(rgbColor !== null && rgbColor !== void 0 ? rgbColor : {
        r: 0, g: 0, b: 0, alpha: 0,
    });
    const styles$1 = {
        backgroundColor: color,
        border: isLight ? '1px solid rgba(0, 0, 0, 0.12)' : '1px solid transparent',
    };
    return (React.createElement("div", { className: [className, styles['color-indicator']].join(' '), style: styles$1 }));
}

export { ColorIndicator };
//# sourceMappingURL=color-indicator.js.map
